/**
 * Component Registry for The Heights at Rock Hill
 * 
 * Inherits from @vibesites-rr-living/theme-prestige and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-rr-living/theme-prestige/registry';
import { Hero } from './components/Hero';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { SharedAmenitiesNote } from './components/SharedAmenitiesNote';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Hero forked from the parent theme to use this property's dusk
  // cinemagraph video (from theheightsatrockhill.com) as the background.
  Hero,
  // Relabel the "Major Employers & Offices" category tab to OTHER.
  NeighborhoodMap,
  // Mutual amenity access note for Heights + Summit residents.
  SharedAmenitiesNote,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
